import axios from 'axios';

async function getAppVersion() {
    return axios.get('/General/AppVersion/');
}

async function getLandingPageUrl() {
    return axios.get('/General/LandingPageUrl/');
}

const generalService = {
    getAppVersion,
    getLandingPageUrl
}

export default generalService;